import * as React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import StudentList from "./StudentList";
import { InterviewBatch } from "@/types";

interface BatchListProps {
  batches: InterviewBatch[];
  openBatchId: string | null;
  onToggleBatch: (batchId: string) => void;
}

const BatchList: React.FC<BatchListProps> = ({
  batches,
  openBatchId,
  onToggleBatch,
}) => {
  if (batches.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No batches found</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {batches.map((batch) => {
        const isOpen = openBatchId === batch._id;
        const batchDisplayName = `${batch.bCode}${
          batch.bTime ? ` (${batch.bTime})` : ""
        }`;

        return (
          <Collapsible
            key={batch._id}
            open={isOpen}
            onOpenChange={() => onToggleBatch(batch._id)}
          >
            <Card>
              <CollapsibleTrigger className="w-full">
                <CardHeader className="bg-gradient-to-r from-red-50/80 via-red-100/50 to-red-100/10 hover:from-red-100 hover:to-red-200 transition-all cursor-pointer dark:bg-red-700">
                  <div className="flex justify-between items-center">
                    <CardTitle className="text-md font-semibold text-[#22C55E]">
                      {batchDisplayName} ({batch.students.length} students)
                    </CardTitle>
                    <span className="text-gray-600">
                      {isOpen ? (
                        <ChevronUp className="w-5 h-5" />
                      ) : (
                        <ChevronDown className="w-5 h-5" />
                      )}
                    </span>
                  </div>
                </CardHeader>
              </CollapsibleTrigger>
              <CollapsibleContent>
                <CardContent className="pt-6">
                  <StudentList students={batch.students} />
                </CardContent>
              </CollapsibleContent>
            </Card>
          </Collapsible>
        );
      })}
    </div>
  );
};

export default BatchList;
